import styles from "./Sobre.module.css";
import imagem from "../../Imgs/game.png";
function Sobre() {
  return (
    <div className={styles.container}>
      <h3 id="sobre">//Sobre</h3>
      <div className={styles.conteudo}>
        <p>
          Entende-se que o ensino de Geografia não deve distanciar-se de
          elementos presentes no cotidiano dos alunos(as), como as tecnologias
          digitais e os jogos. A evolução dos games e da realidade virtual é
          expressiva, pois estes elementos avançam significativamente em
          qualidade gráfica e possibilidades de interação e são acessados por
          uma parcela dos jovens. Já os jogos analógicos também se fazem
          presentes na infância e adolescência de muitos alunos da educação
          básica. Nesse sentido, é possível e necessário que se pense em formas
          de aproximação dessa realidade com o contexto escolar. Assim,
          pretende-se nesse projeto propiciar, no contexto da formação de
          professores, um espaço de pesquisa, diálogo e reflexão sobre ensino de
          Geografia e o universo lúdico dos jogos.
        </p>
        

        <img src={imagem} alt="Garoto jogando video game"></img>
      </div>
    </div>
  );
}
export default Sobre;
